<template>
  <popup
      @updateClosePopup="onCloseDialog"
      @updateSave="onSave"
      height-head="40px"
      :is-btn-safe="!customer_id"
      :title="title"
      is-all-height
  >
    <div class="customerInvoicesCreateWrap">
      <row align-items="flex-start">
        <field
            margin="0 10px 0 0"
            width="300px"
            label="Customer"
            placeholder="Select customer"
            @updateAutocomplete="onAutocomplete($event, 'customer_id')"
            :autocompleteValue="customer_id"
            :items="customers"
            :isClearable="false"
            is-autocomplete
            is-required
            :is-disabled="!!invoiceId"
        ></field>
        <field
            margin="0 10px 10px 0"
            width="150px"
            type="text"
            label="Date from"
            placeholder="Enter date"
            :dateValue="from"
            @updateDate="onDate($event, 'from')"
            is-date
            is-no-title
            :is-readonly="!!invoiceId"
        ></field>
        <field
            margin="0 10px 10px 0"
            width="150px"
            type="text"
            label="Date to"
            placeholder="Enter date"
            :dateValue="to"
            @updateDate="onDate($event, 'to')"
            is-date
            is-no-title
            :is-readonly="!!invoiceId"
        ></field>
        <field
            margin="0 10px 0 0"
            width="150px"
            label="Type"
            placeholder="Select type"
            @updateAutocomplete="onAutocomplete($event, 'type')"
            :autocompleteValue="type"
            item-text="text"
            :items="typeList"
            :isClearable="false"
            is-autocomplete
            :is-disabled="!!invoiceId"
        ></field>
        <field
            margin="0 10px 0 0"
            width="150px"
            label="Status"
            placeholder="Select status"
            @updateAutocomplete="onAutocomplete($event, 'status_id')"
            :autocompleteValue="status_id"
            item-value="status_id"
            item-text="status"
            :items="invoiceStatus"
            :isClearable="false"
            is-autocomplete
        ></field>
        <field
            margin="0 10px 0 0"
            width="300px"
            label="Service"
            placeholder="Select service"
            @updateAutocomplete="onAutocomplete($event, 'services_id')"
            :autocompleteValue="services_id"
            item-text="name"
            :items="service"
            :isClearable="false"
            is-autocomplete
            :is-disabled="!!invoiceId || !customer_id"
        ></field>
        <field
            margin="0 10px 10px 0"
            width="200px"
            label="Balance"
            placeholder="Select balance"
            type="number"
            :setInputValue="balance"
            :isColorInput="balance >= 0"
            icon="dollar"
            is-readonly
        ></field>
        <field
            margin="0 0 10px 0"
            width="240px"
            label="Account"
            placeholder="Select account"
            @updateSelect="onSelect"
            :autocompleteValue="zelle_id"
            :items="zelleAccount"
            itemText="name"
            :isClearable="false"
            is-select
        ></field>
      </row>
      <block-invoices
          v-if="customer_id && services_id"
          :previousInvoice="previousInvoice"
          :notPaidInvoices="notPaidInvoices"
          @updateView="onView"
      ></block-invoices>
      <block-safety
          v-if="services_id === 3"
          :flag="getFlags.SAFETY"
          :safety="safety"
          :invoiceDrivers="invoiceDrivers"
          :switcherReport="switcherReport"
          @updateEditInvoice="onEditInvoice"
          @updateCheckbox="onCheckbox"
      ></block-safety>
      <block-billing
          v-if="services_id === 1"
          :flag="getFlags.BILLING"
          :billingOld="billingOld"
          :billing="billing"
          :billingLoads="billingLoads"
          :switcherReport="switcherReport"
          @updateEditInvoice="onEditInvoice"
          @updateCheckbox="onCheckbox"
      ></block-billing>
      <block-dispatch
          v-if="services_id === 2"
          :flag="getFlags.DISPATCH"
          :invoiceLoads="invoiceLoads"
          :loads="loads"
          :loadsOld="loadsOld"
          :switcherReport="switcherReport"
          :xlsSwitcher="xlsSwitcher"
          @updateEditInvoice="onEditInvoice"
          @updateCheckbox="onCheckbox"
      ></block-dispatch>
      <block-additional
          v-if="customer_id && services_id"
          :flag="getFlags.ADDITIONAL"
          :additionalPayments="additional_payments"
          :payments="payments"
          @updateEditInvoice="onEditInvoice"
          @updateAdditionalPayment="onAdditionalPayment"
      ></block-additional>
      <payments-drawer
          v-if="isPaymentsDrawer"
          @updateClose="onPaymentsDrawerClose"
          @updateSave="onPaymentsDrawerSave"
      ></payments-drawer>
    </div>
  </popup>
</template>
<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// components
import { typeList } from "@/components/Accounting/Invoices/Invoice/constants";
import BlockBilling from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/BlockBilling/BlockBilling.vue";
import BlockInvoices from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/BlockInvoices/BlockInvoices.vue";
import BlockSafety from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/BlockSafety/BlockSafety.vue";
import BlockDispatch from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/BlockDispatch/BlockDispatch.vue";
import { CUSTOMER_INVOICES_FLAGS } from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/constants";
import BlockAdditional
from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/BlockAdditional/BlockAdditional.vue";
import PaymentsDrawer
from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/PaymentsDrawer/PaymentsDrawer.vue";
// shared
import Popup from "@/shared/Popup/Popup.vue";
// helpers
import getDefaultDate from "@/helper/getDefaultDate";
import getUniqId from "@/helper/getUniqId";

export default {
	name: "CustomerInvoicesCreate",
	components: {
		Popup,
		BlockBilling,
		BlockSafety,
		BlockInvoices,
		BlockDispatch,
		BlockAdditional,
		PaymentsDrawer,
	},
	props: {
		title: String,
		invoiceId: Number,
	},
	computed: {
		...mapGetters([ 'customerInvoicesData' ]),
		getFlags() {
			return CUSTOMER_INVOICES_FLAGS;
		}
	},
	data: () => ({
		isPaymentsDrawer: false,
		customer_id: null,
		services_id: null,
		type: 2,
		typeList: [],
		from: getDefaultDate(),
		to: getDefaultDate(),
		status_id: 1,
		service: [],
		balance: null,
		customers: [],
		invoiceStatus: [],
		previousInvoice: [],
		notPaidInvoices: [],
		invoiceDrivers: [],
		billingOld: [],
		billing: [],
		billingLoads: [],
		safety: [],
		invoiceLoads: [],
		loads: [],
		loadsOld: [],
		payments: [],
		additional_payments: [],
		switcherReport: true,
		xlsSwitcher: true,
		zelle_id: 1,
		zelleAccount: [],
	}),
	methods: {
		...mapActions([ 'onCustomerInvoicesData', 'onCustomerInvoicesSave', 'setAlert', 'onAddPayments' ]),
		onCloseDialog(isRefresh) {
			this.$emit('updateCloseDialog', isRefresh);
		},
		onPaymentsDrawerClose() {
			this.isPaymentsDrawer = false;
		},
		async onPaymentsDrawerSave(values) {
			const { status, payment } = await this.onAddPayments(values);
			if (status) {
				this.payments.push(payment);
				this.onPaymentsDrawerClose();
				this.setAlert({ type: "success", message: "Payments save successfully" });
			} else {
				this.setAlert({ type: "error", message: "Payments save error" });
			}

		},
		onView({ file }) {
			this.$emit('updateView', file);
		},
		getInvoicesTableData(values) {
			const arrList = [];
			if (values && !Array.isArray(values)) {
				for (const key in values) {
					if (values[key]) {
						arrList.push(values[key]);
					}
				}
				return arrList;
			}
		},
		onSelect({ value }) {
			this.zelle_id = value?.id ?? value;
		},
		onAddCustomId(array) {
			if (Array.isArray(array)) {
				return array.map(item => {
					item.customId = getUniqId();
					return item;
				});
			}
			return array;
		},
		async onInitData({ id, values, isSelect }) {
			await this.onCustomerInvoicesData({ values, id });
			const {
				invoice,
				customers,
				service,
				invoiceStatus,
				previous_invoice,
				not_paid_invoices,
				safety,
				invoiceDrivers,
				balance,
				billingOld,
				billing,
				billingLoads,
				invoiceLoads,
				loads,
				loadsOld,
				payments,
				additional_payments,
				zelleAccount
			} = this.customerInvoicesData;

			if (!Array.isArray(invoice)) {
				const {
					customer_id,
					from,
					to,
					type,
					status_id,
					services_id,
					zelle_id
				} = invoice;

				if (!isSelect) this.customer_id = customer_id;
				this.from = from;
				this.to = to;
				if (!isSelect) this.type = type;
				this.status_id = status_id;
				this.services_id = services_id;
				this.zelle_id = zelle_id || 1;
			}

			this.zelleAccount = zelleAccount;
			this.customers = customers;
			this.service = service;
			this.invoiceStatus = invoiceStatus;
			this.typeList = typeList;
			this.balance = balance;
			this.previousInvoice = this.getInvoicesTableData(previous_invoice);
			this.notPaidInvoices = not_paid_invoices;
			this.safety = this.onAddCustomId(safety);
			this.invoiceDrivers = this.onAddCustomId(invoiceDrivers);
			this.billingOld = billingOld;
			this.billing = billing;
			this.billingLoads = billingLoads;
			this.invoiceLoads = invoiceLoads;
			this.loads = loads;
			this.loadsOld = loadsOld;
			this.payments = payments;
			this.additional_payments = additional_payments;
		},
		async onAutocomplete({ value }, key) {
			this[key] = value?.id || value?.status_id || value;
			if (key === 'customer_id') {
				this.zelle_id = value.zelle_id;
			}
			
			if ((key === 'customer_id' || key === 'type' || key === 'services_id') && this.services_id) {
				const { customer_id, from, to, type, services_id } = this.$data;
				const values = {
					customer_id,
					from,
					to,
					type,
					services_id
				};
				await this.onInitData({ values, id: this.invoiceId, isSelect: true });
			}
		},
		async onDate(date, key) {
			this[key] = date;
			const { customer_id, from, to, type, services_id } = this.$data;
			if (services_id && customer_id) {

				const values = {
					customer_id,
					from,
					to,
					type,
					services_id
				};
				await this.onInitData({ values, id: this.invoiceId });
			}
		},
		onCheckbox({ value, key }) {
			this[key] = value;
		},
		onEditInvoice({ key, item, nameComponent, isOld }) {
			if (nameComponent === this.getFlags.SAFETY) {
				if (key === 'delete') {
					if (item) {
						const idx = this.invoiceDrivers.findIndex(({ customId }) => customId === item['customId']);
						this.invoiceDrivers.splice(idx, 1);
						this.safety.push(item);
					} else {
						this.safety = [ ...this.safety, ...this.invoiceDrivers ];
						this.invoiceDrivers = [];
					}
				}

				if (key === 'plus') {
					if (item) {
						const idx = this.safety.findIndex(({ customId }) => customId === item['customId']);
						this.safety.splice(idx, 1);
						this.invoiceDrivers.push(item);
					} else {
						this.invoiceDrivers = [ ...this.invoiceDrivers, ...this.safety ];
						this.safety = [];
					}
				}
			}

			if (nameComponent === this.getFlags.BILLING || nameComponent === this.getFlags.BILLING_OLD) {
				if (key === 'delete') {
					if (item) {
						const idx = this.billingLoads.findIndex(({ load_id }) => load_id === item['load_id']);
						this.billingLoads.splice(idx, 1);
						if (item.isOld) {
							this.billingOld.push(item);
						} else {
							this.billing.push(item);
						}
					} else {
						this.billingOldFiltered = this.billingLoads.filter(({ isOld }) => !!isOld);
						this.billingFiltered = this.billingLoads.filter(({ isOld }) => !isOld);
						this.billingOld = [ ...this.billingOld, ...this.billingOldFiltered ];
						this.billing = [ ...this.billing, ...this.billingFiltered ];
						this.billingLoads = [];
					}
				}

				if (key === 'plus') {
					if (item) {
						const loadListKey = item.isOld ? 'billingOld' : 'billing';
						const idx = this[loadListKey].findIndex(({ load_id }) => load_id === item['load_id']);
						this[loadListKey].splice(idx, 1);
						this.billingLoads.push(item);
					} else {
						const loadListKey = isOld ? 'billingOld' : 'billing';
						this.billingLoads = [ ...this.billingLoads, ...this[loadListKey] ];
						this[loadListKey] = [];
					}
				}
			}

			if (nameComponent === this.getFlags.DISPATCH || nameComponent === this.getFlags.DISPATCH_OLD) {
				if (key === 'delete') {
					if (item) {
						const loadListKey = item.isOld ? 'loadsOld' : 'loads';

						const idx = this.invoiceLoads.findIndex(({ load_id }) => load_id === item['load_id']);
						this.invoiceLoads.splice(idx, 1);

						this[loadListKey].push(item);
					} else {
						this.loadsOldFiltered = this.invoiceLoads.filter(({ isOld }) => !!isOld);
						this.loadsFiltered = this.invoiceLoads.filter(({ isOld }) => !isOld);
						this.loadsOld = [ ...this.loadsOld, ...this.loadsOldFiltered ];
						this.loads = [ ...this.loads, ...this.loadsFiltered ];
						this.invoiceLoads = [];
					}
				}

				if (key === 'plus') {
					if (item) {
						const loadListKey = item.isOld ? 'loadsOld' : 'loads';
						const idx = this[loadListKey].findIndex(({ load_id }) => load_id === item['load_id']);
						this[loadListKey].splice(idx, 1);
						this.invoiceLoads.push(item);
					} else {
						const loadListKey = isOld ? 'loadsOld' : 'loads';
						this.invoiceLoads = [ ...this.invoiceLoads, ...this[loadListKey] ];
						this[loadListKey] = [];
					}
				}
			}

			if (nameComponent === this.getFlags.ADDITIONAL) {
				if (key === 'delete') {
					if (item) {
						const idx = this.payments.indexOf(item);
						this.payments.splice(idx, 1);
					} else {
						this.additional_payments = [ ...this.additional_payments, ...this.payments ];
						this.payments = [];
					}
				}
			}
		},
		onAdditionalPayment() {
			this.isPaymentsDrawer = true;
		},
		async onSave() {
			const {
				safety,
				billing,
				billingOld,
				invoiceDrivers,
				loadsBilling,
				billingLoads,
				loads,
				loadsOld,
				invoiceLoads,
				payments,
				additional_payments,
				status_id,
				customer_id,
				services_id,
				type,
				from,
				to,
				switcherReport,
				xlsSwitcher,
				zelle_id,
			} = this.$data;

			const values = {
				safety,
				billing,
				billingOld,
				invoiceDrivers,
				loadsBilling,
				billingLoads,
				loads,
				loadsOld,
				invoiceLoads,
				payments,
				additional_payments,
				status: status_id,
				customer_id,
				services_id,
				type,
				from_date: from,
				to_date: to,
				switcherReport,
				xlsSwitcher,
				zelle_id,
				id: this.invoiceId
			};

			const { status } = await this.onCustomerInvoicesSave(values);
			if (status) {
				const message = this.invoiceId ? 'Invoice updated successfully' : 'Invoice safe successfully';
				this.setAlert({ type: "success", message });
				this.onCloseDialog(1);
			} else {
				this.setAlert({ type: "error", message: "Invoice safe error" });
			}
		}
	},
	async mounted() {
		await this.onInitData({ id: this.invoiceId });
	}
};
</script>

